export const filterReducer = function filterReducer(state, { type, payload }) {
  switch (type) {
    case 'SELECT_COUNTRY':
    case 'SELECT_CITY':
    case 'SELECT_COMPOSER':
    case 'SELECT_COMPANY':
    case 'SELECT_WORK':
      // eslint-disable-next-line no-case-declarations
      const { aggregation_query, aggregation_type, ...existingFilters } = state.query;
      return {
        ...state,
        endpoint: 'productions/aggregations',
        query: {
          aggregation_query: payload.keyword ? payload.keyword : '',
          ...existingFilters,
          ...payload.additionalFilters,
        },
        selectedValue: {
          ...state.selectedValue,
          ...payload.selectedValue,
        },
      };
    case 'CLEAR_COUNTRY':
    case 'CLEAR_CITY':
    case 'CLEAR_COMPOSER':
    case 'CLEAR_COMPANY':
    case 'CLEAR_WORK':
      // eslint-disable-next-line no-case-declarations
      const { query: previousQuery } = state;
      delete previousQuery[payload.id];
      return {
        ...state,
        endpoint: 'productions/aggregations',
        query: { ...previousQuery },
        // Set selectedValue to null and not empty Object
        selectedValue: { ...state.selectedValue, [payload.collection]: null },
      };
    case 'SEARCH_BY_REMOVE_CHARACTERS_COUNTRY':
    case 'SEARCH_BY_REMOVE_CHARACTERS_CITY':
    case 'SEARCH_BY_REMOVE_CHARACTERS_COMPOSER':
    case 'SEARCH_BY_REMOVE_CHARACTERS_COMPANY':
    case 'SEARCH_BY_REMOVE_CHARACTERS_WORK':
      // eslint-disable-next-line no-case-declarations
      const { query: previousStateQuery } = state;
      delete previousStateQuery[payload.id];
      return {
        ...state,
        endpoint: 'productions/aggregations',
        query: { ...previousStateQuery },
      };
    case 'UPDATE_DATE': {
      const new_date_from = typeof payload.new_date_from !== 'undefined' ? payload.new_date_from : state.date_from;
      const new_date_to = typeof payload.new_date_to !== 'undefined' ? payload.new_date_to : state.date_to;
      return { ...state, date_to: new_date_to, date_from: new_date_from };
    }
    case 'UPDATE_VIEW_BY': {
      // Check for presence of tickets and don't Boolean(payload.tickets)
      const by_tickets = typeof payload.tickets !== 'undefined' ? payload.tickets : state.tickets;
      const by_live_stream = typeof payload.live_stream !== 'undefined' ? payload.live_stream : state.live_stream;
      return { ...state, tickets: by_tickets, live_stream: by_live_stream };
    }
    case 'SET_SELECTED_VALUES': {
      const { selectedValue: incomingSelectedValues, query: incomingSelectedQuery, ...rest } = payload.state;
      const selectedValue = { ...state.selectedValue, ...incomingSelectedValues };
      const query = { ...state.query, ...incomingSelectedQuery };
      return { ...state, ...rest, selectedValue, query };
    }
    case 'RESET': {
      return payload.state;
    }
    default: {
      throw new Error(`Unsupported type: ${type}`);
    }
  }
};
